import {
  AppBar,
  IconButton,
  makeStyles,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useThemeType } from '../../contexts/ThemeTypeContext';
import { drawerWidth } from '../../styling';
import MainDrawer from './Drawer';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 65,
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    background:
      'linear-gradient(35deg, ' +
      theme.palette.steicolors.darkside +
      ' 60%, ' +
      theme.palette.steicolors.lightside +
      ' 90%)',
    color: '#e0e0e0',
    height: 65,
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  titlediv: {
    flexGrow: 1,
  },
  title: {
    width: 'min',
    cursor: 'pointer',
    display: 'inline',
    textDecoration: 'none',
    '&:hover': {
      color: '#FFA840',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2rem',
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  img: {
    height: 32,
    width: 'auto',
    marginRight: 8,
    display: 'inline',
    filter: `drop-shadow(0px 1px 0 #fafafa)
    drop-shadow(0px -1px 0 #fafafa)
    drop-shadow(1px 0px 0 #fafafa)
    drop-shadow(-1px 0px 0 #fafafa)`,
  },
}));

export default function Nav() {
  const classes = useStyles();
  const themeHelper = useThemeType();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  let history = useHistory();

  return (
    <div className={classes.root} key="appbardiv">
      <AppBar
        key="appbarmain"
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: themeHelper.drawerState,
        })}
      >
        <Toolbar key="appbartoolbar">
          <IconButton
            key="appbardrawerButton"
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={themeHelper.toggleDrawer}
          >
            <MenuIcon />
          </IconButton>
          <img
            key="appbarsteiicon"
            src="/res/stei-itb.png"
            className={classes.img}
          />
          <div className={classes.titlediv} key="appbartitlediv">
            <Typography
              key="appbartitletypograph"
              variant="h5"
              className={classes.title}
              noWrap={matches ? true : false}
              onClick={() => {
                history.push('/');
              }}
            >
              LAYANAN AKADEMIK STEI ITB
            </Typography>
          </div>
        </Toolbar>
      </AppBar>
      <MainDrawer />
    </div>
  );
}
